import {  motion, useAnimation, useInView } from "framer-motion";
import {  useEffect, useRef } from "react";

/**
 * Props for the Reveal component.


/**
 * Reveal animation component.
 */
const Reveal = ({ children, delay=0.2 }) => {
  // Reference to the element
  const ref = useRef(null);

  // Check if the element is in view
  const inView = useInView(ref, { once: true });

  // Controls for the animation
  const mainControls = useAnimation();

  useEffect(() => {
    if (inView) {
      mainControls.start("visible");
    }
  }, [inView]);

  return (
    <div ref={ref}>
      <motion.div
        variants={{
          initial: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0 }
        }}
        initial="initial"
        animate={mainControls}
        transition={{
          duration: 0.4,
          delay: delay || 0.2,
          ease: "easeInOut",
          staggerChildren: 0.5
        }}
        className="w-full h-full"
      >
        {children}
      </motion.div>
    </div>
  );
};

export default Reveal;